<script setup lang="ts">
import KsoOrderLoaderView from "@innoclouds/ui/templates/kso/ksoOrderLoader/KsoOrderLoader.vue";
import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import defaultCupIcon from "#/assets/icons/cup_white.svg";
import Close from "#/assets/iconsDynamic/Close.vue";
import { useDecorationStore } from "#/store/decoration";
import { useThemeStore } from "#/store/theme";

interface Props {
	immersive?: boolean;
	active?: boolean;
	completed?: boolean;
	backendPhrases?: string[] | null;
	phraseInterval?: number | null;
	decoration?: string;
}

const props = withDefaults(defineProps<Props>(), {
	immersive: true,
	active: true,
	completed: false,
	backendPhrases: null,
	phraseInterval: null,
	decoration: undefined,
});

const emit = defineEmits<{
	cancel: [];
}>();

const { t } = useTranslation();
const themeStore = useThemeStore();
const decor = useDecorationStore().screen(props.decoration);

// @tolgee-key { key: 'kso.loader.phrase.heat', ns: 'translation' }
// @tolgee-key { key: 'kso.loader.phrase.grind', ns: 'translation' }
// @tolgee-key { key: 'kso.loader.phrase.brew', ns: 'translation' }
// @tolgee-key { key: 'kso.loader.phrase.milk', ns: 'translation' }
// @tolgee-key { key: 'kso.loader.phrase.serve', ns: 'translation' }
const PHRASE_KEYS = ["heat", "grind", "brew", "milk", "serve"];

const phrases = computed(() => {
	const fromBackend = (props.backendPhrases ?? []).filter((item) => !!item?.trim());
	// @tolgee-ignore
	return fromBackend.length ? fromBackend : PHRASE_KEYS.map((key) => t(`kso.loader.phrase.${key}`));
});

const themeImage = computed(() => themeStore.data?.loader_screen?.image_link || null);
const cupIcon = computed(() => themeImage.value || defaultCupIcon);
</script>

<template>
	<KsoOrderLoaderView
		:immersive="props.immersive"
		:active="props.active"
		:completed="props.completed"
		:phrases="phrases"
		:phrase-interval="props.phraseInterval"
		:caption="t(`kso.loader.caption`)"
		:hint="t(`kso.loader.hint`)"
		:cup-icon="cupIcon"
		:cup-default-icon="!themeImage"
		:decor="decor"
		@cancel="emit('cancel')"
	>
		<template #close-icon>
			<Close color="#fff" />
		</template>
	</KsoOrderLoaderView>
</template>
